<div>
  <br>

  <div class="col-md-11">

    <form [formGroup]="form">

      <div class="row">

        <div *ngIf="institutionlist.length > 0">
          <label>Institution</label>
          <select class="form-control form-control-sm" #institutionId formControlName="institutionId" (change)="getPossibleSignsEvent($event)"
            required>
            <option></option>
            <option *ngFor="let i of institutionlist" [ngValue]="i.id">{{i.shortName}} {{i.name}}</option>
          </select>
        </div>

        <!-- Kanslist eller sysadmin -->
        <div *ngIf="(isClerk || isSysAdmin) && !isAdmin" style="min-width:300px;">
          <label>Institution</label>
          <div *ngIf="!selectedinstitution">
            <input type="text" class="form-control form-control-sm" id="institutionId" aria-label="Assignee" matInput [formControl]="myControl"
              placeholder="Skriv för att söka institution" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onSelectionChanged($event)">
              <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{option.name}}
                <b>[{{option.shortName}}]</b>
              </mat-option>
            </mat-autocomplete>
          </div>

          <div *ngIf="selectedinstitution">
            <b style="font-size:14px;">{{selectedinstitutionname}}</b>
            <button class="btn border" style="margin-left:20px;" title="Byt institution" (click)="selectedinstitution=null;clear();">Byt institution</button>
          </div>
        </div>

      </div>
      <div class="row">

        <div *ngIf="form.get('institutionId').value">
          <div>
            <label>
              Utmärkelse
            </label>
            <select class="form-control form-control-sm" id="id" formControlName="signId" required>
              <option></option>
              <option *ngFor="let s of signs" [ngValue]="s.id">{{s.name}} [{{s.abbreviation}}]</option>
            </select>
          </div>
        </div>

        <div *ngIf="form.get('institutionId').value" class="col-md-3">
          <label for="fromDate">Datum</label>
          <input type="text" id="fromDate" class="form-control form-control-sm" formControlName="fromDate" mask="0000-00-00" 
            required/>
        </div>
      </div>
      <br>
      <br>

      <div class="row">
        <button class="btn border" (click)="saveSign()" title="Spara utmärkelse" [disabled]="!form.valid">Spara</button>
        <button class="btn border" (click)="cancel()" title="Spara utmärkelse" style="margin-left:10px;">Avbryt</button>
      </div>

    </form>

  </div>
</div>
